






















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import Error from '@/components/Error.vue';
import Success from '@/components/Success.vue';
import ConfirmedAction from '@/components/ConfirmedAction.vue';
import { EnrolProfile } from '@/types';
import { ApiClient, curApiClient } from '@/services/ApiClient';

@Component({
  components: {
    Error,
    Success,
    ConfirmedAction
  },
})
export default class DeleteEnrolProfile extends Vue {

  @Prop({ default: {},  type: Object}) enrolProfile!: EnrolProfile;

  error:string = '';
  success:string = '';

  private apiClient:ApiClient = curApiClient;
  
  async deleteItem() {

    const reply = await this.apiClient.deleteEnrolProfile(this.enrolProfile.enrolId);
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to delete enrol profile: ${reply.errorMsg}`;
    
    this.setSuccess(`Enrol profile ${this.enrolProfile.enrolId} has been deleted`);
  }


  setSuccess(str:string) {
    this.success = str;
    setTimeout(() => this.$emit('cancel'), 1000);
  }

  cancel() {
    this.$emit('cancel');
  }
}
